/**
 * Typography foundation
 * @see https://www.figma.com/file/O0FWE4TJWmIGCksbLUEL0i0y/Web-(Logged-In)?node-id=0%3A808
 */
const FONT_WEIGHT_LIGHT = `font-weight: 300;`;
const FONT_WEIGHT_REGULAR = `font-weight: 400;`;
const FONT_WEIGHT_MEDIUM = `font-weight: 500;`;
const FONT_WEIGHT_BOLD = `font-weight: 700;`;
/**
 * Headings (XLarge)
 * font-size: 42px;
 * line-height: 54px;
 */
const HEADING_XLARGE_MEDIUM = `
  font-size: 2.625rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 3.375rem;
`;
/**
 * Headings (Medium)
 * font-size: 28px;
 * line-height: 42px;
 */
const HEADING_LARGE_MEDIUM = `
  font-size: 1.75rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 2.625rem;
`;
/**
 * font-size: 24px;
 * line-height: 36px;
 */
const HEADING_NORMAL_MEDIUM = `
  font-size: 1.5rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 2.25rem;
`;
/**
 * font-size: 20px;
 * line-height: 30px;
 */
const HEADING_SMALL_MEDIUM = `
  font-size: 1.25rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.875rem;
`;
/**
 * font-size: 20px;
 * line-height: 30px;
 */
const HEADING_SMALL_REGULAR = `
  font-size: 1.25rem;
  ${FONT_WEIGHT_REGULAR}
  line-height: 1.875rem;
`;
/**
 * Headings (Light)
 * font-size: 20px;
 * line-height: 30px;
 */
const HEADING_SMALL_LIGHT = `
  font-size: 1.25rem;
  ${FONT_WEIGHT_LIGHT}
  line-height: 1.875rem;
`;
/**
 * Body (Bold)
 * font-size: 18px;
 * line-height: 28px;
 */
const BODY_LARGE_BOLD = `
  font-size: 1.125rem;
  ${FONT_WEIGHT_BOLD}
  line-height: 1.75rem;
`;
/**
 * Body (Medium)
 * font-size: 16px;
 * line-height: 24px;
 */
const BODY_LARGE_MEDIUM = `
  font-size: 1rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.5rem;
`;
/**
 * Body (Regular)
 * font-size: 16px;
 * line-height: 24px;
 */
const BODY_LARGE_REGULAR = `
  font-size: 1rem;
  ${FONT_WEIGHT_REGULAR}
  line-height: 1.5rem;
`;
/**
 * Body (Light)
 * font-size: 16px;
 * line-height: 24px;
 */
const BODY_LARGE_LIGHT = `
  font-size: 1rem;
  ${FONT_WEIGHT_LIGHT}
  line-height: 1.5rem;
`;
/**
 * font-size: 14px;
 * line-height: 24px;
 */
const BODY_NORMAL_BOLD = `
  font-size: 0.875rem;
  ${FONT_WEIGHT_BOLD}
  line-height: 1.5rem;
`;
/**
 * font-size: 14px;
 * line-height: 24px;
 */
const BODY_NORMAL_MEDIUM = `
  font-size: 0.875rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.5rem;
`;
/**
 * font-size: 14px;
 * line-height: 24px;
 */
const BODY_NORMAL_REGULAR = `
  font-size: 0.875rem;
  ${FONT_WEIGHT_REGULAR}
  line-height: 1.5rem;
`;
/**
 * font-size: 14px;
 * line-height: 24px;
 */
const BODY_NORMAL_LIGHT = `
  font-size: 0.875rem;
  ${FONT_WEIGHT_LIGHT}
  line-height: 1.5rem;
`;
/**
 * font-size: 12px;
 * line-height: 18px;
 */
const BODY_SMALL_MEDIUM = `
 font-size: 0.75rem;
 ${FONT_WEIGHT_MEDIUM}
 line-height: 1.125rem;
`;
/**
 * font-size: 12px;
 * line-height: 18px;
 */
const BODY_SMALL_REGULAR = `
  font-size: 0.75rem;
  ${FONT_WEIGHT_REGULAR}
  line-height: 1.125rem;
`;
/**
 * font-size: 12px;
 * line-height: 18px;
 */
const BODY_SMALL_LIGHT = `
  font-size: 0.75rem;
  ${FONT_WEIGHT_LIGHT}
  line-height: 1.125rem;
`;
/**
 * Textlink (Medium)
 * font-size: 20px;
 * line-height: 30px;
 */
const TEXTLINK_XLARGE_MEDIUM = `
  font-size: 1.25rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.875rem;
  text-decoration: underline;
`;
/**
 * Textlink (Medium)
 * font-size: 16px;
 * line-height: 24px;
 */
const TEXTLINK_LARGE_MEDIUM = `
  font-size: 1rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.5rem;
  text-decoration: underline;
`;
/**
 * font-size: 14px;
 * line-height: 24px;
 */
const TEXTLINK_NORMAL_MEDIUM = `
  font-size: 0.875rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.5rem;
  text-decoration: underline;
`;
/**
 * font-size: 12px;
 * line-height: 18px;
 */
const TEXTLINK_SMALL_MEDIUM = `
  font-size: 0.75rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.125rem;
  text-decoration: underline;
`;
/**
 * font-size: 11px;
 * line-height: 18px;
 */
const TEXTLINK_XSMALL_MEDIUM = `
  font-size: 0.6875rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.125rem;
  text-decoration: underline;
`;
/**
 * Footnote (Medium)
 * font-size: 11px;
 * line-height: 18px;
 */
const FOOTNOTE_XSMALL_MEDIUM = `
  font-size: 0.6875rem;
  ${FONT_WEIGHT_MEDIUM}
  line-height: 1.125rem;
`;
/**
 * Footnote (Regular)
 * font-size: 11px;
 * line-height: 18px;
 */
const FOOTNOTE_XSMALL_REGULAR = `
  font-size: 0.6875rem;
  ${FONT_WEIGHT_REGULAR}
  line-height: 1.125rem;
`;
/**
 * Footnote (Light)
 * font-size: 11px;
 * line-height: 18px;
 */
const FOOTNOTE_XSMALL_LIGHT = `
  font-size: 0.6875rem;
  ${FONT_WEIGHT_LIGHT}
  line-height: 1.125rem;
`;

export { BODY_LARGE_BOLD, BODY_LARGE_LIGHT, BODY_LARGE_MEDIUM, BODY_LARGE_REGULAR, BODY_NORMAL_BOLD, BODY_NORMAL_LIGHT, BODY_NORMAL_MEDIUM, BODY_NORMAL_REGULAR, BODY_SMALL_LIGHT, BODY_SMALL_MEDIUM, BODY_SMALL_REGULAR, FONT_WEIGHT_BOLD, FONT_WEIGHT_LIGHT, FONT_WEIGHT_MEDIUM, FONT_WEIGHT_REGULAR, FOOTNOTE_XSMALL_LIGHT, FOOTNOTE_XSMALL_MEDIUM, FOOTNOTE_XSMALL_REGULAR, HEADING_LARGE_MEDIUM, HEADING_NORMAL_MEDIUM, HEADING_SMALL_LIGHT, HEADING_SMALL_MEDIUM, HEADING_SMALL_REGULAR, HEADING_XLARGE_MEDIUM, TEXTLINK_LARGE_MEDIUM, TEXTLINK_NORMAL_MEDIUM, TEXTLINK_SMALL_MEDIUM, TEXTLINK_XLARGE_MEDIUM, TEXTLINK_XSMALL_MEDIUM };
